'use client';

import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import Script from 'next/script';
import { useEffect } from 'react';

export const BomboraScript = () => {
  useEffect(() => {
    const handleBomboraDataReady = (event: CustomEvent) => {
      if (event?.detail?.tmpSegment) {
        FreestarAdSlot.setPageTargeting('bmb', event.detail.tmpSegment);
        // Update Nativo config with Bombora targeting key-values
        if (!window.ntvConfig) {
          window.ntvConfig = { keyValues: {} };
        }
        window.ntvConfig.keyValues.bombora = event.detail.tmpSegment.toString();
      }
    };
    window.addEventListener('bomboraDataReady', handleBomboraDataReady as EventListener);
    return () => {
      window.removeEventListener('bomboraDataReady', handleBomboraDataReady as EventListener);
    };
  }, []);
  return (
    <Script
      // biome-ignore lint/security/noDangerouslySetInnerHtml: This is a third-party script that needs to be loaded
      dangerouslySetInnerHTML={{
        __html: `
          !function(e,t,c,n,o,a,m){e._bmb||(o=e._bmb=function(){o.x?o.x.apply(o,arguments):o.q.push(arguments)},o.q=[],a=t.createElement(c),a.async=true,a.src="https://vi.ml314.com/get?eid=91560&tk=pz1S3PHbmG2bxjdly0eNosi1ACrbASlXUkF1oGj39mY03d&fp="+(e.localStorage&&e.localStorage.getItem(n)||""),m=t.getElementsByTagName(c)[0],m.parentNode.insertBefore(a,m))}(window,document,"script","_ccmaid");
          _bmb('vi', function(data) {
              if (data != null) {
                var tmpSegment = [
                  data.industry_id,
                  data.revenue_id,
                  data.size_id,
                  data.functional_area_id,
                  data.professional_group_id,
                  data.seniority_id,
                  data.decision_maker_id,
                  data.install_data_id,
                  data.topic_id,
                  data.interest_group_id,
                  data.segment,
                  data.b2b_interest_cluster_id
                  ].filter(Boolean).join(',');
                window.dispatchEvent(new CustomEvent('bomboraDataReady', { detail: { tmpSegment } }));
              }
          });
        `,
      }}
      id='bombora'
    />
  );
};
